export default "__VITE_ASSET__CtfYUu7p__"